import { FormLookupsContext } from "@ngt/opms";
import { ILookup } from "../../../api/dtos";
import { FC, PropsWithChildren, useContext, useMemo } from "react";


export interface IFormLookupsModifierProps extends PropsWithChildren {
    modifyFn: (lookups?: ILookup[]) => ILookup[] | undefined;
}

const FormLookupsModifier: FC<IFormLookupsModifierProps> = ({
    modifyFn,
    children
}) => {
    const lookups = useContext(FormLookupsContext);

    const modifiedLookups = useMemo(() => {
        return modifyFn(lookups)
    }, [lookups, modifyFn])

    return (
        <FormLookupsContext.Provider value={modifiedLookups}>
            {
                children
            }
        </FormLookupsContext.Provider>
    );
}

export default FormLookupsModifier;